module.exports = __webpack_public_path__ + "img/logo-white.aa19f791.png";